import { render, staticRenderFns } from "./FlagsIcons.vue?vue&type=template&id=2099f910&scoped=true&"
import script from "./FlagsIcons.vue?vue&type=script&lang=js&"
export * from "./FlagsIcons.vue?vue&type=script&lang=js&"
import style0 from "./FlagsIcons.vue?vue&type=style&index=0&id=2099f910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2099f910",
  null
  
)

export default component.exports